import {useEffect} from "react";
import {observer} from "mobx-react";
import {useSearchStream} from "../hooks/useSearchStream";

/**
 * Observer component that connects to SSE stream when searchStreamId changes
 * and updates SearchSessionStore with stream events.
 *
 * This component should be rendered wherever search results are displayed.
 */
const SearchStreamObserver = observer(({searchSessionStore}) => {
  const streamId = searchSessionStore.searchStreamId;

  // Connect to SSE stream and handle events
  useSearchStream(streamId, searchSessionStore.authData, {
    onProgress: (progress, total, info) => {
      searchSessionStore.handleStreamProgress(progress, total, info);
    },
    onResults: (data) => {
      searchSessionStore.handleStreamResults(data);
    },
    onError: (error) => {
      searchSessionStore.handleStreamError(error);
    },
  });

  // This component doesn't render anything
  return null;
});

export default SearchStreamObserver;